const REACT_APP_APP_VERSION = window.ENV
  ? window.ENV.REACT_APP_APP_VERSION
  : process.env.REACT_APP_APP_VERSION;

export default {
  version: REACT_APP_APP_VERSION,
};
